import { FormActions } from "../../components/common/FormActions";
import {
  createViewEdit,
  formatDate,
  getForm,
  stringifyName,
} from "../../utils/helpers";
import { URL_ALLOWANCE_TYPES_CONFIGURABLES } from "../../utils/urls";

export const useAllowanceTypeConfigurables = () => {
  const tableColumns = () => [
    { id: "type_of_allowance", header: "Allowance_type " },
    { id: "status", header: "Status" },
    { id: "actions", header: "Actions" },
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      const row = {
        ...item,
        created_at: formatDate(item.created_at),
        actions: (
          <FormActions
            actions={createViewEdit(
              URL_ALLOWANCE_TYPES_CONFIGURABLES,
              item?.id,
            )}
          />
        ),
      };
      return row;
    }),
  ];

  const viewData = (item: any) => {
    return {
      type_of_allowance: item?.type_of_allowance,
      status: item?.status,
      created_by: stringifyName({ ...item?.created_by }),
      created_at: formatDate(item?.created_at),
    };
  };

  const formRoute = getForm(URL_ALLOWANCE_TYPES_CONFIGURABLES);
  return { tableColumns, tableData, formRoute, viewData };
};
